const BEASTBUILDER_STEPS = ["profile", "bb1", "bb2", "bb3", "finished"];

// Get the step to continue from after abandoning tutorial
const getBeastbuilderContinueStep = function(step) {
	if (step === "bb1" || step === "bb2") return "bb3";
	else return step;
};

module.exports = {
	BEASTBUILDER_STEPS,
	getBeastbuilderContinueStep,
};
